import { noop } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { $rqViewsApiClient } from "@/api/groups"
import { query } from "@/api/query"
import { getXOrganizationHeaders } from "@/api/utils"
import { routeGuard } from "@/lib/routing/beforeLoad"
import { queryClient } from "@/lib/services/instances"

export const Route = createFileRoute("/_authlayout/_sidebar/trash/")({
  beforeLoad: async ({ context }) => {
    // TODO: no dedicated flag for viewing trash yet (was a "TBD: Frontend Flags" CSV entry);
    // restrictions::read is always granted, so this is effectively unguarded until one exists.
    await routeGuard(context, { permission: { flag: "restrictions::read" } })
  },
  loader: ({ context: { spaceStorage } }) => {
    const space = spaceStorage.getSpace()

    queryClient.query(query.space.members(space)).catch(noop)

    queryClient
      .query(
        $rqViewsApiClient.queryOptions("get", "/groups/v1/trash", {
          params: {
            header: getXOrganizationHeaders(space)
          }
        })
      )
      .catch(noop)
  },
  head: () => ({
    meta: [
      {
        title: "Trash | Arduino Cloud"
      }
    ]
  })
})
